import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import defultUser from "../../../../../src/assets/defultImage/defult-user.png";
import moment from "moment/moment";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import ScreenRecordShow from "../../../Reuseable/ScreenRecordShow";
import Countdown from 'react-countdown';
var imgUrl =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8&w=1000&q=80";

function UserCallList({ item, index, from }) {
  const { imageCdnUrl } = useContext(serverInfo);

  const [callJoinBuffer, setCallJoinBuffer] = useState(false);
  const [timeCounter, setTimeCounter] = useState(false);
  const [url, setUrl] = useState();
  const [token, setToken] = useState();
  const [callStatus, setCallStatus] = useState(true);
  const [btnStatus, setBtnStatus] = useState(true)

  const authName = localStorage.getItem("auth_name");
  const authType = localStorage.getItem("auth_type");
  var RoomLink;

  useEffect(() => {
    // getToken()
    if (item.publish_status == 0) {
      setCallStatus(false);
    }
  }, [item]);

  const timeCount = () => {
    let eventDate = item?.live_chat_date;
    let startTime = item?.live_chat_start_time;
    let endTime = item?.live_chat_end_time;

    let now = moment(Date.now());
    let start = moment(eventDate + " " + startTime);

    let diff = start.diff(now, 'second')

    let starTime
    if (diff > 0) {
      starTime = start

    } else {
      starTime = now

    }


    let end = moment(eventDate + " " + endTime);

    return end.valueOf() - starTime.valueOf();

    // let end = moment(item?.live_chat_date + " " + item?.live_chat_end_time)
    // let now = moment(Date.now())

    // return end.diff(now, 'second')

  };


  const endTimeCalculation = () => {

    let end = moment(item?.live_chat_date + " " + item?.live_chat_end_time)
    let now = moment(Date.now())

    if (end.diff(now, 'second') > 0) {
      return true
    } else {
      return false
    }

  }

  let minute = timeCount() / 60000;


  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {

      setTimeCounter(true);
      setBtnStatus(false)
      // Render a completed state
      return <div className="">
        <div className="bg-secondary text-center text-dark rounded px-2 py-2">
          <p className="p-0 m-0">Time End</p>

        </div>
      </div>;
    } else {
      // Render a countdown

      return <div className="d-flex justify-content-center align-items-center">
        <div className="bg-warning text-center text-dark rounded px-2 ">
          <p className="p-0 m-0">{hours}</p>
          <small className="p-0 m-0 text-muted">HH</small>


        </div>
        <div className="bg-warning text-center text-dark rounded px-2 mx-2">
          <p className="p-0 m-0">{minutes}</p>
          <small className="p-0 m-0 text-muted">MM</small>


        </div>
        <div className="bg-warning text-center text-dark rounded px-2 ">
          <p className="p-0 m-0">{seconds}</p>
          <small className="p-0 m-0 text-muted">SS</small>


        </div>

      </div>
    }
  };

  const rendererRunnig = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      sessionClose()
      setTimeCounter(true);
      // Render a completed state
      return <div className="">
        <div className="bg-warning text-center text-dark rounded px-1 py-2">
          <p className="p-0 m-0">Time End</p>

        </div>
      </div>;
    } else {
      // Render a countdown
      return <div className="d-flex justify-content-center align-items-center">
        <div className="bg-warning text-center text-dark rounded px-2 ">
          <p className="p-0 m-0">{hours}</p>
          <small className="p-0 m-0 text-muted">HH</small>


        </div>
        <div className="bg-warning text-center text-dark rounded px-2 mx-2">
          <p className="p-0 m-0">{minutes}</p>
          <small className="p-0 m-0 text-muted">MM</small>


        </div>
        <div className="bg-warning text-center text-dark rounded px-2 ">
          <p className="p-0 m-0">{seconds}</p>
          <small className="p-0 m-0 text-muted">SS</small>


        </div>

      </div>
    }
  };




  /**
   * leav call
   */
  const sessionClose = () => {
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/videoEnd/${item.room_id}/${token}`).then((res) => {
          setCallStatus(false);
        });
      })
      .catch((err) => {
        // alert('network problem')
      });
  };

  /**
   * join call
   */
  const joinCall = () => {
    setCallJoinBuffer(true);
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          setCallJoinBuffer(false);
          setToken(res.data.token);

          if (authType == "admin") {
            window.open(
              `/video-meeting?token=${res.data.token}&meetingId=${item.room_id}&webcamEnabled=false&micEnabled=false&name=${authName}&star=${item?.live_chat?.star?.first_name + " " + item?.live_chat?.star?.last_name}&staradmin=${item?.live_chat?.admin?.first_name + " " + item?.live_chat?.admin?.last_name}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
            );
          } else {
            window.open(
              `/video-meeting?token=${res.data.token}&meetingId=${item.room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&star=${item?.live_chat?.star?.first_name + " " + item?.live_chat?.star?.last_name}&staradmin=${item?.live_chat?.admin?.first_name + " " + item?.live_chat?.admin?.last_name}&time=${timeCount() / 60000}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
            );
          }

          setTimeCounter(true);
          setCallStatus(false);
        });
      })
      .catch((err) => {
        // alert('network problem')
      });
  };

  // useEffect(() => {

  //     const myTimeout = setTimeout(sessionClose, minute * 1000);
  // }, [])

  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td className="w-50">
          <div className=" d-flex">
            <div className="mx-5">
              <img
                src={item.user.image ? imageCdnUrl + item.user.image : defultUser}
                className="img-fluid"
                style={{
                  height: 45,
                  width: 45,
                  backgroundColor: "green",
                  borderRadius: "50%",
                }}
                alt=""
              />
            </div>
            <span className="d-flex justiy-content-center align-items-center">
              {item.user.first_name + " " + item.user.last_name}

            </span>
          </div>
        </td>
        <td
        // style={{
        //   display: "flex",
        //   flexDirection: "row",
        //   alignItems: "center",
        // }}
        >

          {timeCounter ?
            <Countdown
              date={Date.now() + timeCount()}
              renderer={rendererRunnig}
            />
            :
            <>
              {minute > 0 ? minute.toFixed(2) : 0} {endTimeCalculation()}{" minute  "}
            </>
          }

          {/* <div style={{ marginLeft: "50px" }}>
            <CountdownCircleTimer
              size={70}
              strokeWidth={5}
              isPlaying={timeCounter}
              duration={minute * 60}
              colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
              colorsTime={[7, 5, 2, 0]}
              onComplete={() => setCallStatus(false)}
            >
              {({ remainingTime }) => remainingTime}
            </CountdownCircleTimer>


          </div> */}

        </td>
        <td>
          <Countdown
            date={new Date(item?.live_chat_date + " " + item?.live_chat_start_time)}
            renderer={renderer}
          />
        </td>
        <td className="bg-danger">


          {endTimeCalculation() &&
            <button
              className="btn btn-success btn-sm w-50 d-flex justify-content-center align-items-center"
              onClick={callStatus ? joinCall : null}
              style={{ height: 50, width: 100, padding: "5px 10px 5px" }}
              disabled={btnStatus}
            >
              {callJoinBuffer ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                <i
                  className="fa-solid fa-phone"
                  color="red"
                  style={{ fontSize: 25 }}
                ></i>
              )}
            </button>
          }



        </td>
      </tr>
      <tr>
        <td colspan="5" height={40}>
          <ScreenRecordShow roomId={item?.room_id} />
        </td>
      </tr>
    </>
  );
}

export default UserCallList;
